import { useCallback, useState } from 'react';
import { useUser } from '../../providers/UserProvider';
import { gpSeenRelease, shouldShowOnboarding } from '../whatsNew/seenRelease';
import { useMarkGpReleaseSeen } from '../whatsNew/useMarkGpReleaseSeen';
import { CURRENT_RELEASE } from '../whatsNew/useWhatsNew';

interface UseOnboardingResult {
    shouldShow: boolean;
    onDismiss: () => void;
}

export function useOnboarding(): UseOnboardingResult {
    const { user } = useUser();
    const markSeen = useMarkGpReleaseSeen('Failed to mark onboarding as seen:');
    const [dismissed, setDismissed] = useState(false);

    const shouldShow = !dismissed && shouldShowOnboarding(gpSeenRelease(user?.database?.data));

    const onDismiss = useCallback(() => {
        setDismissed(true);
        void markSeen(CURRENT_RELEASE);
    }, [markSeen]);

    return { shouldShow, onDismiss };
}
